import './index.css';
import Cursor from './components/Cursor';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import Divider from './components/Divider';
import Capabilities from './components/Capabilities';
import Terminal from './components/Terminal';
import Onchain from './components/Onchain';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Cursor />
      <Navbar />
      <Hero />
      <StatsBar />
      <Divider />
      <Capabilities />
      <Terminal />
      <Divider />
      <Onchain />
      <Divider />
      <CtaSection />
      <Footer />
    </>
  );
}
